import { type HTMLAttributes, forwardRef } from 'react';
import classnames from 'classnames';
// Import Styles
import styles from './FilterDependencyDots.module.scss';

type DependencyTileProps = HTMLAttributes<HTMLDivElement>;

/**
 * 20x20 white tile used inside `DependencyPill` for icons that sit next to the dependency dots
 * (e.g. the filter description info icon). Forwards the ref so it can be a `Tooltip` target.
 */
const DependencyTile = forwardRef<HTMLDivElement, DependencyTileProps>(({ className, children, ...rest }, ref) => (
    <div ref={ref} className={classnames(styles.dependencyDotsTile, className)} {...rest}>
        {children}
    </div>
));

DependencyTile.displayName = 'DependencyTile';

export default DependencyTile;
